import { gql } from "@apollo/client";

export const GET_FABRIC_GROUPS = gql`
  query GET_FABRIC_GROUPS(
    $searchTerm: String
    $language: EnumLanguageFilter
    $take: Int
    $skip: Int
    $orderBy: [FabricGroupOrderByWithRelationInput!]
    $filters: [FabricGroupWhereInput]
  ) {
    findManyFabricGroupCount(
      where: {
        OR: [
          {
            fabric_group_profiles: {
              some: {
                name: { mode: insensitive, contains: $searchTerm }
                language: $language
              }
            }
          }
          { code: { mode: insensitive, contains: $searchTerm } }
        ]
        AND: $filters
      }
    )

    findManyFabricGroup(
      orderBy: $orderBy
      where: {
        OR: [
          {
            fabric_group_profiles: {
              some: {
                name: { mode: insensitive, contains: $searchTerm }
                language: $language
              }
            }
          }
          { code: { mode: insensitive, contains: $searchTerm } }
        ]
        AND: $filters
      }
      take: $take
      skip: $skip
    ) {
      id
      code
      createdAt
      fabric_group_profiles {
        id
        name
        language
      }

      manufacturerId

      manufacturer {
        id
        company_name
        manufacturer_profiles {
          name
          language
        }
      }

      type

      fabric_price_category {
        id
        group_number
        manufacturerId
      }

      fabrics {
        id
        code
        color_name
        image {
          src
        }
      }
    }
  }
`;

export const GET_FABRIC_GROUPS_WITH_FABRIC_SEARCH = gql`
  query GET_FABRIC_GROUPS_WITH_FABRIC_SEARCH(
    $searchTerm: String
    $language: EnumLanguageFilter
    $take: Int
    $skip: Int
    $orderBy: [FabricGroupOrderByWithRelationInput!]
    $filters: [FabricGroupWhereInput]
  ) {
    findManyFabricGroupCount(
      where: {
        OR: [
          {
            fabric_group_profiles: {
              some: {
                name: { mode: insensitive, contains: $searchTerm }
                language: $language
              }
            }
          }
          { code: { mode: insensitive, contains: $searchTerm } }
          { fabrics: { some: { color_name: { mode: insensitive, contains: $searchTerm } } } }
          { fabrics: { some: { code: { mode: insensitive, contains: $searchTerm } } } }
        ]
        AND: $filters
      }
    )

    findManyFabricGroup(
      orderBy: $orderBy
      where: {
        OR: [
          {
            fabric_group_profiles: {
              some: {
                name: { mode: insensitive, contains: $searchTerm }
                language: $language
              }
            }
          }
          { code: { mode: insensitive, contains: $searchTerm } }
          { fabrics: { some: { color_name: { mode: insensitive, contains: $searchTerm } } } }
          { fabrics: { some: { code: { mode: insensitive, contains: $searchTerm } } } }
        ]
        AND: $filters
      }
      take: $take
      skip: $skip
    ) {
      id
      code
      createdAt
      fabric_group_profiles {
        id
        name
        language
      }

      manufacturerId

      manufacturer {
        id
        company_name
        manufacturer_profiles {
          name
          language
        }
      }

      type

      fabric_price_category {
        id
        group_number
        manufacturerId
      }

      fabrics {
        id
        code
        color_name
        image {
          src
        }
      }
    }
  }
`;

export const DELETE_MANY_FABRICS = gql`
  mutation DELETE_MANY_FABRICS($ids: [Int!]!) {
    deleteManyFabricGroup(where: { id: { in: $ids } }) {
      count
    }
  }
`;

export const CORE_FABRIC_GROUP_DATA = gql`
  fragment CoreFabricGroupData on FabricGroup {
    id
    # createdAt
    type
    code
    fabric_group_profiles {
      id
      name
      description
      language
    }

    manufacturer {
      id
    }

    fabrics {
      id
      code
      color_name
      order
      image {
        src
      }
    }

    water_repelant
    virus_protection
    non_flammable
    pet_friendly
    environment_friendly
    easy_water_cleaning

    fabric_features {
      id
      fabric_feature {
        id
        code
        photo {
          src_xs
          src
        }
        fabric_feature_profiles {
          name
          language
        }
      }
    }

    link_to_manufacturer_page
  }
`;

export const UPDATE_FABRIC_GROUP = gql`
  mutation UPDATE_FABRIC_GROUP(
    $where: FabricGroupWhereUniqueInput!
    $fabric_group_profiles: [FabricGroupProfileCustomInput!]!
    $fabrics: [FabricCustomInput!]!
    $manufacturer: Int!
    $fabric_type: FabricType!
    $water_repelant: Boolean!
    $virus_protection: Boolean!
    $non_flammable: Boolean!
    $pet_friendly: Boolean!
    $environment_friendly: Boolean!
    $easy_water_cleaning: Boolean!
    $link_to_manufacturer_page: String
    $code: String
    $fabric_feature_ids: [Int]
  ) {
    updateExistingFabricGroup(
      where: $where
      fabric_group_profiles: $fabric_group_profiles
      fabrics: $fabrics
      manufacturer: $manufacturer
      fabric_type: $fabric_type
      water_repelant: $water_repelant
      virus_protection: $virus_protection
      non_flammable: $non_flammable
      pet_friendly: $pet_friendly
      environment_friendly: $environment_friendly
      easy_water_cleaning: $easy_water_cleaning
      link_to_manufacturer_page: $link_to_manufacturer_page
      code: $code
      fabric_feature_ids: $fabric_feature_ids
    ) {
      id
    }
  }
`;

export const CREATE_FABRIC_GROUP = gql`
  mutation CREATE_FABRIC_GROUP(
    $fabric_group_profiles: [FabricGroupProfileCustomInput!]!
    $fabrics: [FabricCustomInput!]!
    $manufacturer: Int!
    $fabric_type: FabricType!
    $water_repelant: Boolean!
    $virus_protection: Boolean!
    $non_flammable: Boolean!
    $pet_friendly: Boolean!
    $environment_friendly: Boolean!
    $easy_water_cleaning: Boolean!
    $link_to_manufacturer_page: String
    $code: String
    $fabric_feature_ids: [Int]
  ) {
    createNewFabricGroup(
      fabric_group_profiles: $fabric_group_profiles
      fabrics: $fabrics
      manufacturer: $manufacturer
      fabric_type: $fabric_type
      water_repelant: $water_repelant
      virus_protection: $virus_protection
      non_flammable: $non_flammable
      pet_friendly: $pet_friendly
      environment_friendly: $environment_friendly
      easy_water_cleaning: $easy_water_cleaning
      link_to_manufacturer_page: $link_to_manufacturer_page
      code: $code
      fabric_feature_ids: $fabric_feature_ids
    ) {
      # ...CoreCollectionData
      id
    }
  }
`;

export const DELETE_FABRIC_GROUP = gql`
  mutation DeleteFabricGroup($where: FabricGroupWhereUniqueInput!) {
    deleteOneFabricGroup(where: $where) {
      id
    }
  }
`;

export const GET_FABRIC_GROUP = gql`
  query GET_FABRIC_GROUP($id: Int!) {
    findUniqueFabricGroup(where: { id: $id }) {
      id
      type
      code
      fabric_group_profiles {
        id
        name
        description
        language
      }
      manufacturer {
        id
      }
      fabrics {
        id
        code
        color_name
        order
        image {
          src
        }
      }
      water_repelant
      virus_protection
      non_flammable
      pet_friendly
      environment_friendly
      easy_water_cleaning
      fabric_features {
        id
        fabric_feature {
          id
          code
          photo {
            src_xs
            src
          }
          fabric_feature_profiles {
            name
            language
          }
        }
      }
      link_to_manufacturer_page
    }
  }
`;

export const GET_ALL_FABRIC_FEATURES = gql`
  query GET_ALL_FABRIC_FEATURES {
    findManyFabricFeature(orderBy: { id: asc }) {
      id
      code
      photo {
        src_xs
        src
      }
      fabric_feature_profiles {
        name
        language
      }
      fabricFeatureGroupId
      fabric_feature_group {
        id
        fabric_feature_group_profiles {
          name
          language
        }
      }
    }
  }
`;
